export default {
  'wire.enterAmountIn': 'Enter Amount In',
  'wire.AmountScreenReader': 'Amount In <%= currency %>',
  'wire.enterAmountInFinePrint':
    'Note: This payment will be sent in the foreign currency you have designated above. As the exchange rate may not be final, the actual USD amount to be debited from your account will be calculated at the time the payment is sent based on the FX Amount to be Sent. Please refer to Payment Information summary.',
  'wires.confirmationWithNumberSymbol': 'Confirmation #',
  'wires.bankCode.domestic': 'Domestic List',
  'wires.bankCode.international': 'International List',
  'wires.infoDisplay.wireDomestic': 'Wire - Domestic',
  'wires.titles.createWirePayment': 'Create Wire Payment',
  'wires.titles.copyWirePayment': 'Copy Wire Payment',
  'wires.titles.initiateWirePayment': 'Initiate Wire Payment',
  'wires.titles.modifyWirePayment': 'Modify Wire Payment',
  'wires.titles.viewWirePayment': 'View Wire Payment',
  'wires.titles.createWireTemplate': 'Create Wire Template',
  'wires.titles.modifyWireTemplate': 'Modify Wire Template',
  'wires.titles.viewWireTemplate': 'View Wire Template',
  'wires.titles.copyWireTemplate': 'Copy Wire Template',
  'wires.titles.bankToBankInformation': 'Bank To Bank Information',
  'wires.titles.instructionsForBeneficiaryBank': 'Instructions for Beneficiary Bank',
  'wires.titles.originatorToBeneficiaryInformation': 'Originator To Beneficiary Information',
  'wires.titles.reviewWirePayment': 'Review Wire Payment',
  'wires.titles.selectBankCodeType': 'select bank code type',
  'wires.amountType.C': 'Foreign Currency',
  'wires.amountType.D': 'USD',
  'wires.international.charges.BEN': 'Beneficiary',
  'wires.international.charges.OUR': 'Ours',
  'wires.international.charges.SHA': 'Share',
  'wires.delete.success': 'Payment Deleted',
  'wires.context.useWire.error':
    'useWire must be used within WireContext.Provider, WireDispatchContext.Provider, and WireFormContext.Provider',
  'wires.error.loading': 'Error loading <%= matchingPaymentType %> payment type!',
  'wires.accordions.screenReaderHeader': 'View <%= wireInfo %>',
  'wires.addressUpdateRequired':
    'System requires the beneficiary address to be re-entered. The beneficiary address information is as follows.',
  'wires.actionNotEligible':
    'This wire payment is not eligible for the selected action. Please create a new wire payment from the originating wire template.',
  'wires.templateActionNotEligible':
    'This wire template is not eligible for the selected action. Please modify the wire template to update the beneficiary address.',
  'wires.international.serviceMessage': 'International Wire Service Message',
  'wires.foreignCurrency.serviceMessage': 'Foreign Currency Wire Service Message',
  'wires.domestic.serviceMessage': 'Domestic Wire Service Message',
  'wires.iban.label': 'Account Type IBAN',
  'wires.iban.invalidIban': 'Invalid IBAN',
  'wires.iban.toolTip':
    'Select "Yes" from the dropdown menu if you are using an IBAN (International Bank Account Number). An IBAN is an alphanumeric code used to identify certain international bank accounts.  One distinguishing feature of an IBAN is the first two characters in the code are alpha and indicate the country in which the account is held.'
};
